import { RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  NOTIFICATION_TYPE_LABELS,
  notificationTypeTagClass,
} from '@/constants/notification';
import type { NotificationListItem } from '@/types/notification';

interface MobileNotificationCardProps {
  item: NotificationListItem;
  onClick?: () => void;
}

function formatNotificationTime(value: string): string {
  const parsed = dayjs(value);
  if (!parsed.isValid()) {
    return '-';
  }
  const now = dayjs();
  if (now.diff(parsed, 'day') < 1) {
    return parsed.format('HH:mm');
  }
  if (now.diff(parsed, 'day') < 7) {
    return parsed.format('MM-DD HH:mm');
  }
  return parsed.format('MM-DD HH:mm');
}

export function MobileNotificationCard({ item, onClick }: MobileNotificationCardProps) {
  const isUnread = item.readStatus === 'UNREAD';

  return (
    <article
      className={`mobile-card mobile-card--link mobile-notification-card${isUnread ? ' mobile-notification-card--unread' : ''}`}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          onClick();
        }
      }}
    >
      <div className="mobile-card__header">
        <div className="mobile-notification-card__title-row">
          {isUnread ? <span className="mobile-notification-card__dot" aria-hidden /> : null}
          <span className="mobile-card__title">{item.title}</span>
        </div>
        <span className={notificationTypeTagClass(item.type)}>
          {NOTIFICATION_TYPE_LABELS[item.type]}
        </span>
      </div>
      <p className="mobile-notification-card__content">{item.content}</p>
      <div className="mobile-notification-card__meta">
        <span>{formatNotificationTime(item.createdAt)}</span>
        <span>{isUnread ? '未读' : '已读'}</span>
      </div>
      {onClick ? (
        <div className="mobile-card__footer">
          <span>查看详情</span>
          <RightOutlined />
        </div>
      ) : null}
    </article>
  );
}
